import { render, staticRenderFns } from "./FormSellerCustomerPage.vue?vue&type=template&id=7fc6be78&scoped=true"
import script from "./FormSellerCustomerPage.vue?vue&type=script&lang=js"
export * from "./FormSellerCustomerPage.vue?vue&type=script&lang=js"
import style0 from "./FormSellerCustomerPage.vue?vue&type=style&index=0&id=7fc6be78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6be78",
  null
  
)

export default component.exports